import { RootState } from 'rootReducer';

export const kioskSelector = (state: RootState) => state.kioskModuleReducer.kioskReducer;
